export default __webpack_public_path__ + "static/media/live-ge-checkmark.d72b2b31.svg";